import { createIntegrationKey, deleteIntegrationKey, fetchIntegrationKeys } from './integration-keys.utils';

const integrationKeys = {
    namespaced: true,
    state: {
        error: {},
        integrationKeyList: [],
        newIntegrationKey: {},
    },
    mutations: {
        addNewKeyToList (state, { integrationKey }) {
            state.integrationKeyList.push(integrationKey);
            state.newIntegrationKey = {};
        },
        addNewIntegrationKey (state, { integrationKey }) {
            state.newIntegrationKey = integrationKey;
        },
        deleteIntegrationKeyFromList (state, { id }) {
            state.integrationKeyList = state.integrationKeyList.filter((key) => key.id !== id);
        },
        setError (state, { error }) {
            state.error = error;
        },
        setIntegrationKeys (state, { integrationKeys }) {
            state.integrationKeyList = integrationKeys;
        },
    },
    actions: {
        async createIntegrationKey ({ commit }, integrationKey) {
            try {
                const { data } = await createIntegrationKey({ integrationKey });
                commit('addNewIntegrationKey', { integrationKey: data });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async getIntegrationKeys ({ commit }) {
            try {
                const { data } = await fetchIntegrationKeys();

                commit('setIntegrationKeys', { integrationKeys: data });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async deleteIntegrationKey ({ commit }, { integrationKeyId }) {
            try {
                await deleteIntegrationKey({ id: integrationKeyId });
                commit('deleteIntegrationKeyFromList', { id: integrationKeyId });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        list: (state) => state.integrationKeyList,
        createdIntegrationKey: (state) => state.newIntegrationKey,
    },
};

export default integrationKeys;
